import { useDispatch } from 'react-redux';
import descriptionAlertSlice from './dynamicSnackbarSlice.ts';
import { useCallback } from 'react';
import { SnackbarTypeEnum } from './SnackbarTypeEnum.ts';

export default function useDynamicSnackbar() {
  const dispatch = useDispatch();

  const closeSnackbar = useCallback(() => {
    dispatch(descriptionAlertSlice.actions.close());
  }, [dispatch]);

  const openSuccessSnackbar = useCallback(
    (body: string, autoHideDuration: number | undefined = undefined) => {
      closeSnackbar()
      dispatch(
        descriptionAlertSlice.actions.open({
          type: SnackbarTypeEnum.SUCCESS,
          body,
          autoHideDuration,
        }),
      );
    },
    [dispatch],
  );

  const openFailSnackbar = useCallback(
    (body: string, autoHideDuration: number | undefined = undefined) => {
      closeSnackbar()
      dispatch(
        descriptionAlertSlice.actions.open({
          type: SnackbarTypeEnum.ERROR,
          body,
          autoHideDuration,
        }),
      );
    },
    [dispatch],
  );

  return { openSuccessSnackbar, openFailSnackbar, closeSnackbar };
}
